import apiSlice from "./ApiSlice";

export const searchHistoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //PAN
    getPanApplicationSearchBySRN: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/pan-app/admin/view-with-srn?srn=${srn}`,
        method: "GET",
      }),
    }),

     //PAN
    getPanApplicationSearchByACK: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/pan-app/admin/view-with-ack?srn=${srn}`,
        method: "GET",
      }),
    }),

    //ITR
    getItrApplicationSearchBySRN: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/itr-application/admin/view-with-srn?srn=${srn}`,
        method: "GET",
      }),
    }),

    getItrApplicationSearchByACK: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/itr-application/admin/view-with-ack?srn=${srn}`,
        method: "GET",
      }),
    }),

    //GUMASTA
    getGumastaApplicationSearchBySRN: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/gumasta-application/admin/view-with-srn?srn=${srn}`,
        method: "GET",
      }),
    }),
    getGumastaApplicationSearchByACK: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/gumasta-application/admin/view-with-ack?srn=${srn}`,
        method: "GET",
      }),
    }),
    //DSC
    getDscApplicationSearchBySRN: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/dsc-application/admin/view-with-srn?srn=${srn}`,
        method: "GET",
      }),
    }),
    getDscApplicationSearchByACK: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/dsc-application/admin/view-with-ack?srn=${srn}`,
        method: "GET",
      }),
    }),

    //MSME
    getMsmeApplicationSearchBySRN: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/msme-application/admin/view-with-srn?srn=${srn}`,
        method: "GET",
      }),
    }),
    getMsmeApplicationSearchByACK: builder.query({
      providesTags: ["static-pages"],
      query: (srn) => ({
        url: `/msme-application/admin/view-with-ack?srn=${srn}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useGetPanApplicationSearchBySRNQuery,
  useGetPanApplicationSearchByACKQuery,
  useGetDscApplicationSearchBySRNQuery,
  useGetDscApplicationSearchByACKQuery,
  useGetItrApplicationSearchBySRNQuery,
  useGetItrApplicationSearchByACKQuery,
  useGetGumastaApplicationSearchBySRNQuery,
  useGetGumastaApplicationSearchByACKQuery,
  useGetMsmeApplicationSearchBySRNQuery,
  useGetMsmeApplicationSearchByACKQuery
} = searchHistoryApi;
